import "./Corporate.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurLegacy from "./sections/OurLegacy";
import LeadershipAndProjects from "./sections/LeadershipAndProjects";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function CorporatePage() {
  return <div>
      <MainNavigation />
      <OurLegacy />
      <LeadershipAndProjects />
      <SecurityIntelligenceFooter />
    </div>;
}